import { render, staticRenderFns } from "./pictorial-information.vue?vue&type=template&id=e8c52750&"
import script from "./pictorial-information.vue?vue&type=script&lang=js&"
export * from "./pictorial-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8c52750')) {
      api.createRecord('e8c52750', component.options)
    } else {
      api.reload('e8c52750', component.options)
    }
    module.hot.accept("./pictorial-information.vue?vue&type=template&id=e8c52750&", function () {
      api.rerender('e8c52750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/components/pictorial-information.vue"
export default component.exports